import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { pageTitle } from "@/client/lib/page-title";
import { ensureTenantData } from "@/client/lib/session";
import { NotePage } from "@/features/notes/components/note-page";
import { notesQuery } from "@/features/notes/notes-query";

export const Route = createFileRoute("/_authenticated/$slug/notes/$noteId")({
  head: async ({ match }) => {
    const { notesCopy } = await import("@/features/notes/copy");
    return {
      meta: [{ title: pageTitle(notesCopy.title, match.context.companyName) }],
    };
  },
  loader: ({ context }) => ensureTenantData(context.queryClient, notesQuery),
  component: Note,
});

/** Opened from the list's one copy of every note, so opening a note sends nothing. */
function Note() {
  const { slug, noteId } = Route.useParams();
  const { companyTimezone } = Route.useRouteContext();
  const { data: notes } = useSuspenseQuery(notesQuery);
  const note = notes.find((one) => one.id === noteId);
  // Keyed, so another note starts a fresh page with its own words.
  return (
    <NotePage key={noteId} slug={slug} note={note} timeZone={companyTimezone} />
  );
}
